import Tab from '@mui/material/Tab/Tab';
import Tabs from '@mui/material/Tabs';
import React from 'react';
import { useSelector } from 'react-redux';
import useTheme from '../../utilities/hooks/theme';

interface Props {
  onChangeTab?: any;
  activeTab?: number;
  routes?: any;
}

const TransactionHistoryTabBarWeb = ({ onChangeTab, activeTab, routes = [] }: Props) => {
  const { AccountTheme: theme } = useTheme();
  let { themeType = '' } = useSelector((state: any) => state.setting);

  const activeTabStyle = {
    backdropFilter: themeType !== 'dark' ? theme.transactionHistoryActivebackdropFilter : '',
    boxShadow: themeType !== 'dark' ? theme.transactionHistoryActiveboxShadow : '',
    backgroundImage: themeType !== 'dark' ? theme.transactionHistoryActivebackgroundImage : '',
    background: themeType === 'dark' ? theme.transactionHistoryTabActiveBg : ''
  };
  const defaultTabStyle = {
    backdropFilter: themeType !== 'dark' ? theme.transactionHistoryDefaultbackdropFilter : '',
    boxShadow: themeType !== 'dark' ? theme.transactionHistoryDefaultboxShadow : '',
    backgroundImage: themeType !== 'dark' ? theme.transactionHistoryDefaultbackgroundImage : '',
    background: themeType === 'dark' ? theme.transactionHistoryTabDefaultBg : ''
  };

  return (
    <Tabs
      onChange={onChangeTab}
      value={activeTab}
      style={{
        minHeight: 0,
        padding: 0
      }}
      TabIndicatorProps={{
        style: { background: 'transparent' }
      }}>
      {routes.map((item: any, index: any) => {
        const { key, title } = item;
        const isActive = activeTab === index;
        const tabStyle = isActive ? activeTabStyle : defaultTabStyle;
        return (
          <Tab
            key={key}
            sx={{ width: '200px' }}
            style={{
              ...tabStyle,
              flex: 1,
              minHeight: 0,
              padding: 0,
              border: 'none',
              fontFamily: 'Poppins',
              fontSize: '1.1rem',
              fontWeight: 600,
              textTransform: 'none',
              height: '40px',
              color: isActive ? '#000e37' : '#fff'
            }}
            label={`${title}`}
            value={index}
          />
        );
      })}
    </Tabs>
  );
};
export default React.memo(TransactionHistoryTabBarWeb);
